import { useState } from 'react';

const useUserAuthorizationInfo = () => {
  const [userAuthorizationInfo, setUserAuthorizationInfo] = useState({
    error: null,
    isAuthorized: null,
  });

  return {
    setUserAuthorizationInfo,
    userAuthorizationInfo,
  };
};

export default useUserAuthorizationInfo;
